/**
 * O que os paineis de numeros devolvem.
 *
 * Fica em `domain` porque tem dois donos: o painel da EMPRESA (a tela `dashboard`)
 * e o painel de um PACIENTE (o componente `patient-analytics`, montado em tres
 * lugares). Os dois falam o mesmo vocabulario - media, indice de saude, serie no
 * tempo - contra endpoints diferentes.
 */
import { formatDuration, formatTemperatureVariation } from './format';
import { fromBackend } from './instant';
/**
 * Os pontos de uma serie como o painel os le: a hora de cada um no fuso de quem olha.
 *
 * Mora aqui pela mesma razao do tipo - o painel da empresa e o de um paciente pedem a
 * serie, e os dois agrupam por fatia de `date`. O ponto diario do sono ja chega como a
 * meia-noite de quem pede, em UTC, e volta a meia-noite aqui.
 */
export function timeSeriesFromBackend(points) {
    return points.map((point) => ({ ...point, date: fromBackend(point.date) }));
}
/** O que um cartao de media diz quando o periodo nao teve medicao - o mesmo do grafico. */
export const NO_MEASUREMENT = 'Sem medição no período';
/**
 * As medias do periodo escritas para os cartoes, ou `undefined` onde NAO houve medicao.
 *
 * O backend diz "nao houve" com `null`. Ate 08/10/2026 ele mandava zero (`0`, `00:00`,
 * `0/0`), e os cartoes escreviam "0 bpm" ao lado de um grafico que dizia "Sem medição no
 * período"; o painel geral e o do colaborador tinham cada um a sua copia destas regras.
 *
 * A temperatura e a VARIACAO sobre 36 °C, como a curva a desenha (B-03).
 */
export function averageTexts(averages) {
    const measured = (value, write) => value === null ? undefined : write(value);
    return {
        // `7h 24min`, como o eixo e o balao do grafico - e nao o `07:24` que o backend
        // escreve em `sleepAverageFormatted`.
        SONO: measured(averages.sleepAverageSeconds, formatDuration),
        PRESSAO: averages.bloodPressureFormatted ?? undefined,
        OXIGENACAO: measured(averages.oxygenSaturationAverage, (v) => `${Math.round(v)}%`),
        FREQUENCIA_CARDIACA: measured(averages.heartRateAverage, (v) => `${Math.round(v)} bpm`),
        HRV: measured(averages.hrvAverage, (v) => `${Math.round(v)} ms`),
        TEMPERATURA: measured(averages.temperatureAverage, (v) => formatTemperatureVariation(v - 36))
    };
}
//# sourceMappingURL=analytics.js.map